import JSZip from 'jszip'

export async function parsePages(file: File): Promise<ArrayBuffer> {
  const arrayBuffer = await file.arrayBuffer()
  const zip = await JSZip.loadAsync(arrayBuffer)

  // Try QuickLook/Preview.pdf first, then preview.pdf
  const previewPaths = ['QuickLook/Preview.pdf', 'preview.pdf']

  for (const path of previewPaths) {
    const pdfFile = zip.file(path)
    if (pdfFile) {
      return await pdfFile.async('arraybuffer')
    }
  }

  throw new Error('Could not extract PDF preview from Pages file')
}
